import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { RESIZE_URL } from 'utils/restapi';
import { patchMobileAppsLink } from 'redux/links/actions';

import CommonImageDropzone from 'components/common/CommonImageDropzone';

import './MobileAppLinkThumbnail.css';

class MobileAppLinkThumbnail extends Component {
  static propTypes = {
    patchMobileAppsLink: PropTypes.func.isRequired,
    linkId: PropTypes.number.isRequired,
    thumbnail: PropTypes.string,
  };

  static defaultProps = {
    thumbnail: null,
  };

  state = {
    showLoader: false,
  };

  _onImageRemove = () => {
    const form = new FormData();
    form.append('thumbnail', '');
    this.props.patchMobileAppsLink(this.props.linkId, form);
  };

  _onImageDrop = droppedImage => {
    if (droppedImage) {
      const form = new FormData();
      form.append('thumbnail', droppedImage.imageBlob, droppedImage.name);
      this.props.patchMobileAppsLink(this.props.linkId, form);
    }

    this.setState({ showLoader: true });
  };

  render() {
    const { thumbnail } = this.props;

    return (
      <Translation>
        {(t) => (
          <div className="mobile-app-link-thumbnail__component">
            <div
              className="image-wrapper"
              style={{ backgroundImage: thumbnail && `url(${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=96/${thumbnail})` }}
            />

            <div className="buttons-block">
              <CommonImageDropzone
                onDropImage={this._onImageDrop}
              >
                {t("Upload new icon")}
              </CommonImageDropzone>

              {thumbnail &&
                <div
                  className="delete-icon"
                  onClick={this._onImageRemove}
                  tabIndex={-1}
                  role="button"
                >
                  {t("Delete")}
                </div>
              }
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    patchMobileAppsLink,
  },
)(MobileAppLinkThumbnail);
